import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_material_editorService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { materialId: number }): 
  Promise<{ result: { Id?: number, AllowReceiving?: boolean, ControllerTypeId?: number, Description?: string, IsFixedLength?: boolean, IsFixedWeight?: boolean, LookupCode?: string, MaterialGroupId?: number, MinimumDatingSpan?: number, MobileSkipCountBack?: boolean, Name?: string, ProjectId?: number, ScanSerialOfAllPackageLevels?: boolean, ShelfLifeSpan?: number, SkipCycleCount?: boolean, StatusId?: number, StorageCategoryRuleId?: number, StorageCategoryRule?: { Id?: number, Name?: string }, MaterialGroup?: { Id?: number, Name?: string } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_material_editor/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
